import {Form} from "./Form";

export class DataForm extends Form {

  constructor(config) {
    super($.extend({
      errorMap: {}
    }, config));
  }

  submitHandler(form, event) {
    let data = this.getFormData();
    this.detachFormError();

    if (this.triggerMethodOn('beforeSubmit', [data]) === false) {
      return;
    }

    let res = this.invoke('onSubmit', [data]);
    if (!res) {
      return;
    }
    this.ui.form.addClass('loading');
    this.ui.submitButton.prop('disabled', true);

    res
      .finally(() => {
        this.ui.form.removeClass('loading');
        this.ui.submitButton.prop('disabled', false);
        this.triggerMethodOn('finally');
      })
      .then(this.handleSuccess.bind(this))
      .catch(this.handleError.bind(this));
  }

  handleSuccess(...args) {
    this.validator.resetForm();
    this.triggerMethodOn('success', args);
  }

  handleError(resp) {
    if (this.triggerMethodOn('beforeError', [resp]) === false) {
      return;
    }

    let message = resp.message;
    if (resp.errCode && resp.errCode.startsWith("HTTP_STATUS_")) {
      message = this.t(`error.status${resp.status}`);
    }

    if (resp.errCode && this.config.errorMap[resp.errCode]) {
      let elem = this.config.errorMap[resp.errCode];

      message = this.t(elem.message);
      if (elem.name) {
        let errors = {
          [elem.name]: message
        };
        this.validator.invalid[elem.name] = true;
        this.validator.showErrors(errors);
      }
      else if (elem.getPropertyNames) {
        let errors = {};
        elem.getPropertyNames(resp).forEach(propName => {
          errors[propName] = message;
          this.validator.invalid[propName] = true;
        });
        this.validator.showErrors(errors);
      }
      else {
        this.setFormError(message);
      }
    }
    else if (!resp.handled) {
      this.setFormError(message);
      this.validator.resetForm();
    }
    this.triggerMethodOn('error', [resp]);
  }

}